import React from 'react'
import { Grid } from 'semantic-ui-react'

// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'

import { getName, isRequired } from '../../../helpers'
import { FORM_NAME } from '../../../constants'
import translate from '../../translate'

const style = {
  borderBottom: '1px solid rgba(34,36,38,.15)',
}

const OrganizationInformation = ({ fields, selects, dynamicOptions, onTranslateAltRequest }) => {
  return (
    <Grid.Row columns={1} style={style}>
      <Grid.Column>
        <FormLayout label={translate('lbl_name')} visible={!!fields.FullName} labelFieldProportions="5:11">
          <FormField
            autoFocus
            name={getName(fields.FullName)}
            type="text"
            required={isRequired(fields.FullName)}
            maxLength={fields.FullName ? fields.FullName.MaxLen : -1}
            onBlur={onTranslateAltRequest('FullName_ALT')}
          />
          <FormField
            type="text"
            name="FullName_ALT"
            placeholder={translate('txt_full_name_alt')}
            required={isRequired(fields.FullName_ALT)}
            maxLength={fields.FullName_ALT ? fields.FullName_ALT.MaxLen : -1}
          />
        </FormLayout>

        <FormLayout label={translate('lbl_legalstatus')} visible={!!fields.LegalStatusID} labelFieldProportions="5:11">
          <FormField
            name={getName(fields.LegalStatusID)}
            options={selects.Legalstatus.slice(2)}
            type="select"
            search
            required={isRequired(fields.LegalStatusID)}
          />
        </FormLayout>

        <FormLayout
          visible={!!(fields.ORG_IndustryID || fields.ORG_IndustrySubID)}
          labelFieldProportions="5:11"
          label={translate('lbl_industry')}
        >
          <FormField
            visible={!!fields.ORG_IndustryID}
            name={getName(fields.ORG_IndustryID)}
            options={selects.Industry}
            type="select"
            search
            flags={
              fields.ORG_IndustrySubID && {
                modifies: {
                  modifier: 'ORG_IndustryID',
                  field: { ORG_IndustrySubID: selects.Subindustry },
                  form: FORM_NAME,
                },
              }
            }
            required={isRequired(fields.ORG_IndustryID)}
            childOptions={selects.Subindustry}
          />
        </FormLayout>

        <FormLayout
          visible={!!(fields.ORG_IndustryID || fields.ORG_IndustrySubID)}
          labelFieldProportions="5:11"
          label={translate(' ')}
        >
          <FormField
            visible={!!fields.ORG_IndustrySubID}
            name={getName(fields.ORG_IndustrySubID)}
            options={dynamicOptions.Subindustry}
            flags={
              fields.ORG_IndustrySubID && {
                modifies: {
                  modifier: 'ORG_IndustrySubDetailID',
                  field: { ORG_IndustrySubDetailID: selects.IndustrySubDetail },
                  form: FORM_NAME,
                },
              }
            }
            required={isRequired(fields.ORG_IndustrySubID)}
            type="select"
            search
          />
          <FormField
            visible={!!fields.ORG_IndustrySubDetailID}
            name={getName(fields.ORG_IndustrySubDetailID)}
            options={dynamicOptions.IndustrySubDetail}
            required={isRequired(fields.ORG_IndustrySubDetailID)}
            type="select"
            search
          />
        </FormLayout>

        <FormLayout
          label={translate('lbl_businesstype')}
          visible={!!fields.BusinessTypeID}
          labelFieldProportions="5:11"
        >
          <FormField
            name={getName(fields.BusinessTypeID)}
            type="text"
            required={isRequired(fields.BusinessTypeID)}
            maxLength={fields.BusinessTypeID ? fields.BusinessTypeID.MaxLen : -1}
          />
        </FormLayout>

        <FormLayout
          visible={!!(fields.ORG_OwnerStatusID || fields.ORG_Owner)}
          labelFieldProportions="5:11"
          label={translate('lbl_owner')}
        >
          <FormField
            visible={!!fields.ORG_OwnerStatusID}
            name={getName(fields.ORG_OwnerStatusID)}
            options={selects.Ownerstatus}
            required={isRequired(fields.ORG_OwnerStatusID)}
            type="select"
            search
          />

          <FormField
            visible={!!fields.ORG_Owner}
            name={getName(fields.ORG_Owner)}
            type="text"
            required={isRequired(fields.ORG_Owner)}
            maxLength={fields.ORG_Owner ? fields.ORG_Owner.MaxLen : -1}
          />
        </FormLayout>

        <FormLayout
          visible={!!(fields.ORG_FinInstID || fields.ORG_GovRelID)}
          labelFieldProportions="5:11"
          label={translate('lbl_fin_gov')}
        >
          <FormField
            visible={!!fields.ORG_FinInstID}
            name={getName(fields.ORG_FinInstID)}
            options={selects.FinInst}
            required={isRequired(fields.ORG_FinInstID)}
            type="select"
            search
          />

          <FormField
            visible={!!fields.ORG_GovRelID}
            name={getName(fields.ORG_GovRelID)}
            options={selects.GovRel}
            required={isRequired(fields.ORG_GovRelID)}
            type="select"
            search
          />
        </FormLayout>

        <FormLayout
          visible={!!(fields.IND_Resident || fields.ORG_TransparencyID)}
          labelFieldProportions="5:11"
          label={translate('lbl_resident')}
        >
          <FormField
            visible={!!fields.IND_Resident}
            name={getName(fields.IND_Resident)}
            options={selects.Resident}
            required={isRequired(fields.IND_Resident)}
            type="select"
            search
          />

          <FormField
            visible={!!fields.ORG_TransparencyID}
            name={getName(fields.ORG_TransparencyID)}
            required={isRequired(fields.ORG_TransparencyID)}
            options={selects.Transparency}
            type="select"
            search
          />
        </FormLayout>

        <FormLayout label={translate('lbl_risk_level_t')} visible={!!fields.RiskLevelID} labelFieldProportions="5:11">
          <FormField
            name={getName(fields.RiskLevelID)}
            options={selects.RiskLevels}
            type="select"
            search
            required={isRequired(fields.RiskLevelID)}
          />
        </FormLayout>
      </Grid.Column>
    </Grid.Row>
  )
}

export default OrganizationInformation
